import { SharePointResourcesBaseModel } from '../../microsoft/sharepoint/share-point-resources-base-model';

export class SharePointLearningProtectResourcesModel extends SharePointResourcesBaseModel {
  learningDuration: string|null;
}
